import React from "react";
import { Trans, useTranslation } from "react-i18next";

const TermsAndConditions = () => {
  const { t } = useTranslation(["termsAndConditions"]);
  const numberOfItems = 10;
  return (
    <main className="terms-and-conditions-container py-3 px-5">
      <h6>{t("termsAndConditions.title")}</h6>
      <section>
        <h6> {t("termsAndConditions.introduction")}</h6>
        <Trans> {t("termsAndConditions.introductionContent")}</Trans>
        <ol className="main-list">
          {Array.from({ length: numberOfItems }).map((_, index) => (
            <span
              dangerouslySetInnerHTML={{
                __html: t(`termsAndConditions.items.item${index + 1}`),
              }}
            />
          ))}
        </ol>
      </section>
    </main>
  );
};

export default TermsAndConditions;
